import { StudioLogger } from '@studio/logger';

const LOG = new StudioLogger('dailyVideoControl');

/**
 * Interface representing a Daily call instance with video control methods
 */
/* eslint-disable no-unused-vars */
export interface DailyCallInstance {
  setLocalVideo(enabled: boolean): Promise<any>;
}

/**
 * Toggles video for a Daily attendee by enabling/disabling the local video
 * @param dailyCall - The Daily call instance to control video for
 * @param enabled - Whether to enable (true) or disable (false) the video
 * @returns {Promise<void>}
 */
export const toggleDailyVideo = async (dailyCall: DailyCallInstance, enabled: boolean): Promise<void> => {
  try {
    await dailyCall.setLocalVideo(enabled);
    LOG.info(`Daily Local video ${enabled ? 'enabled' : 'disabled'}`);
  } catch (error) {
    LOG.error(`Failed to set Daily video enabled: ${enabled}`, error);
    throw error;
  }
};
